import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CodeUpdateModal from "../../../../modal/PC/system/CodeUpdateModal";
import styled from "styled-components";
import { AppContext } from '../../../../AppStore';
import { useNavigate, useLocation } from "react-router-dom";

const Code = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [rows, setRows] = useState();
    const [columns, setColumns] = useState([]);
    const [detailRows, setDetailRows] = useState();
    const [detailColumns, setDetailColumns] = useState([]);
    const [keyword, setKeyword] = useState({
        search:''
    });
    const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectCodeID, setSelectCodeID] = useState('');

    // Grid정의
    const handleSetting = () => {
        setColumns([
            (MenuUpdateExistYN === "Y"?
            {
                field: 'updated',
                headerName: '수정',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem  icon={<EditIcon color={ MenuUpdateYN === "Y" && params.row.code_add_yn === "Y"? "primary" : "grey"} />} onClick={() => {UpdateClick(params)}} label="Edit" disabled={ MenuUpdateYN === "Y" && params.row.code_add_yn === "Y"? false : true } />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {})
            ,
            { field: 'id', headerName: 'code_seq', width: 0, headerAlign: 'center' },
            { field: 'company_id', headerName: 'company_id', width: 0, headerAlign: 'center' },
            { field: 'code_add_yn', headerName: 'code_add_yn', width: 0, headerAlign: 'center' },
            { field: 'code_solution_yn', headerName: 'code_solution_yn', width: 0, headerAlign: 'center' },
            { field: 'code_detail_name_order_yn', headerName: 'code_detail_name_order_yn', width: 0, headerAlign: 'center' },
            { field: 'code_name', headerName: '코드명', width: 250, headerAlign: 'center' },
            { field: 'code_desc', headerName: '코드설명', width: 300, headerAlign: 'center' },
            { field: 'code_order', headerName: '순서', width: 0, headerAlign: 'center', align:'right', type:'number' },
        ]);

        setDetailColumns([
            (MenuUpdateExistYN === "Y"?
            {
                field: 'deleted',
                headerName: '삭제',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem  icon={<DeleteIcon color={ MenuUpdateYN === "Y" && params.row.code_detail_update_yn === "Y" && params.row.update_flag === 'Y'? "error" : "grey"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuUpdateYN === "Y" && params.row.code_detail_update_yn === "Y" && params.row.update_flag === 'Y'? false : true } />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {})
            ,
            { field: 'id', headerName: 'code_detail_seq', width: 0, headerAlign: 'center' },
            { field: 'code_id', headerName: 'code_id', width: 0, headerAlign: 'center' },
            { field: 'company_id', headerName: 'company_id', width: 0, headerAlign: 'center' },
            { field: 'code_detail_type', headerName: 'code_detail_type', width: 0, headerAlign: 'center' },
            { field: 'code_detail_type_name', headerName: 'code_detail_type_name', width: 0, headerAlign: 'center' },
            { field: 'code_detail_update_yn', headerName: 'code_detail_update_yn', width: 0, headerAlign: 'center' },
            { field: 'code_detail_name', headerName: '상세코드명', width: 200, headerAlign: 'center' },
            { field: 'code_detail_desc', headerName: '상세코드설명', width: 250, headerAlign: 'center' },
            { field: 'code_detail_order', headerName: '순서', width: 70, headerAlign: 'center', align:'right', type:'number' },
            { field: 'code_detail_value', headerName: '상세코드값1', width: 100, headerAlign: 'center', align:'left' },
            { field: 'code_detail_value2', headerName: '상세코드값2', width: 100, headerAlign: 'center', align:'left' },
            { field: 'code_detail_value3', headerName: '상세코드값3', width: 100, headerAlign: 'center', align:'left' },
            { field: 'reg_user_name', headerName: '등록자', width: 120, headerAlign: 'center', align:'center' }
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        company_id: false,
        code_add_yn: false,
        code_solution_yn: false,
        code_detail_name_order_yn: false,
        code_name: true,
        code_desc: true,
        code_order: false,
        updated: true
    });

    const [detailColumnVisibilityModel, setDetailColumnVisibilityModel] = useState({
        id: false,
        code_id: false,
        company_id: false,
        code_detail_type: false,
        code_detail_type_name: false,
        code_detail_update_yn: false,
        code_detail_name: true,
        code_detail_desc: true,
        code_detail_order: true,
        code_detail_value: false,
        code_detail_value2: false,
        code_detail_value3: false,
        reg_user_name: true,
        deleted: true
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);
    
    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> 권한체크가 되면 MenuID가 변경되므로, 권한체크 후 Grid 설정.
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInit();
            handleView();
        }
    }, [MenuID]);

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> 코드 Grid 선택이 바뀌면 조회됨.
        if(selectCodeID !== '' && typeof selectCodeID !== 'undefined'){
            handleViewSub(selectCodeID);
        }
    }, [selectCodeID]);

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);

        axios.get('/api/p/Code/List',
            {
            params : {
              search : keyword.search
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            if(response.status === 200){
                setDetailRows([]);
                const array = response.data.map((item, index) => ({
                    id: item.code_seq,
                    company_id: item.company_id,
                    code_add_yn: item.code_add_yn,
                    code_solution_yn: item.code_solution_yn,
                    code_detail_name_order_yn: item.code_detail_name_order_yn,
                    code_name: item.code_name,
                    code_desc: item.code_desc,
                    code_order: item.code_order
                }));
                setRows(array);
            }else{
                appStore.capture();
            }
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        });
    }

    // Grid 데이터 조회
    const handleViewSub = (searchCode) => {
        if(searchCode !== ''){
            if (appStore.loading) return;
            appStore.setLoading(true);
            
            axios.get('/api/p/Code/DetailList/'+searchCode)
            .then((response) => {
                if(response.status === 200){
                    const PermissionMap = {};
                    response.data.forEach(row => {
                        if (!PermissionMap[row.code_detail_seq]) {
                            PermissionMap[row.code_detail_seq] = [row.reg_user_id, row.update_user_id].includes(Number(localStorage.getItem('user_id')));
                        }
                    });
                    
                    const array = response.data.map((item, index) => ({
                        id: item.code_detail_seq,
                        company_id: item.company_id,
                        code_id: searchCode,
                        code_detail_type: item.code_detail_type,
                        code_detail_type_name: item.code_detail_type_name,
                        code_detail_update_yn: item.code_detail_update_yn,
                        code_detail_name: item.code_detail_name,
                        code_detail_desc: item.code_detail_desc,
                        code_detail_order: item.code_detail_order,
                        code_detail_value: item.code_detail_value,
                        code_detail_value2: item.code_detail_value2,
                        code_detail_value3: item.code_detail_value3,
                        reg_user_name: item.reg_user_name,
                        update_flag: PermissionMap[item.code_detail_seq] ? 'Y' : 'N'
                    }));
                    setDetailRows(array);
                }else{
                    appStore.capture();
                }
            })
            .catch((error) => {
                appStore.capture();
            })
            .finally(() => {
                appStore.setLoading(false); 
            });
        }
    }

    const handleInit = () => {
        setKeyword({
            search:''
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            company_id: false,
            code_add_yn: false,
            code_solution_yn: false,
            code_detail_name_order_yn: false,
            code_name: true,
            code_desc: true,
            code_order: false,
            updated: true
        });

        setDetailColumnVisibilityModel({
            id: false,
            company_id: false,
            code_id: false,
            code_detail_type: false,
            code_detail_type_name: false,
            code_detail_update_yn: false,
            code_detail_name: true,
            code_detail_desc: true,
            code_detail_order: true,
            code_detail_value: false,
            code_detail_value2: false,
            code_detail_value3: false,
            deleted: true
        });
    };

    const UpdateClick = (object) => {
        setSelectCodeID(object.row.id);
        setModalTitle(object.row.code_name+' 상세코드 수정');
        setUpdateModalOpen(true);
    };

    const DeleteClick = (object) => {
        Swal.fire({
            title: '상세코드 '+object.row.code_detail_name+' 삭제',
            html : '상세코드 '+object.row.code_detail_name+'을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton : true,
            confirmButtonColor : "#d33",
            confirmButtonText : "삭제",
            cancelButtonText : "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                // 권세현 : 해당 상세코드 삭제 처리.
                if (appStore.loading) return;
                appStore.setLoading(true);

                axios.post('/api/p/Code/Delete', new URLSearchParams({
                    delete_code_detail_id: object.row.id
                }),
                { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){
                        Swal.fire({
                            title: '상세코드 '+object.row.code_detail_name+' 삭제 완료',
                            text: '정상적으로 상세코드 '+object.row.code_detail_name+'가 삭제 되었습니다.',
                            confirmButtonText: '확인',
                            timer: 5000,
                            timerProgressBar: true
                        }).then((result) => {
                            handleViewSub(object.row.code_id);
                        });
                    }else{
                        appStore.capture();
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .finally(() => {
                    appStore.setLoading(false); 
                });
            }
        });
    };

    const handleExcel = () => {
        var filename = '코드관리'
        axios.get('/api/p/Code/Excel',
        {   
            params : { search : keyword.search, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    {isUpdateModalOpen && (
                        <CodeUpdateModal
                            title={modalTitle}
                            onClose={() => {
                                setUpdateModalOpen(false);
                            }}
                            handleViewSub={handleViewSub}
                            CodeSeq={selectCodeID}
                            originRows={detailRows}
                            MenuUpdateYN={MenuUpdateYN}
                            MenuDeleteYN={MenuDeleteYN}
                        />
                    )}
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            코드
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <input type="text" placeholder="코드" value={keyword.search} name="search" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="off" />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                        </div>
                        <div className="menu-keyword-sub-keyword">
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            
                        </div>
                        <div className="menu-keyword-sub-keyword">
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                        </div>
                        <div className="menu-keyword-sub-keyword">
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div style={ {  width: '100%' } }>
                    <div className="grid_sub" style={ {  width: '650px', float: 'left', fontSize: '17px' } }>
                        <DataGrid
                            className="grid_main"
                            rows={rows}
                            columns={columns}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            columnVisibilityModel={columnVisibilityModel}
                            onRowSelectionModelChange={(newSelectedIds) => {
                                setSelectCodeID(newSelectedIds[0]);
                            }}
                            selectedIds={selectCodeID}
                            AlternatingRowBackground="LavenderBlush"
                            rowsPerPageOptions={[20, 50, 100]}
                        />
                    </div>
                    <div className="grid_sub" style={ { width: '20px', float: 'left' } }>
                    </div>
                    <div className="grid_sub" style={ { width: 'calc(100% - 670px)', float: 'right', fontSize: '17px' } }>
                        <DataGrid
                            className="grid_main"
                            rows={detailRows}
                            columns={detailColumns}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            columnVisibilityModel={detailColumnVisibilityModel}
                            AlternatingRowBackground="LavenderBlush"
                            rowsPerPageOptions={[20, 50, 100]}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default Code;
